import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { AuditOutlined, LaptopOutlined, ReloadOutlined } from '@ant-design/icons';

import { Row, Col, Table, Button, Badge } from 'antd';

import AntDesignTable from '../../Components/AntDesignTable';
import PickingCriteriaList01Actions from '../../Stores/PickingCriteriaList01/Actions';

class PickingCriteriaList01Table extends React.PureComponent {
  constructor() {
    super();

    this.useOnTableChange = this.useOnTableChange.bind(this);
    this.useShowWorkspace = this.useShowWorkspace.bind(this);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.getDocumentColumns = this.getDocumentColumns.bind(this);
  }

  componentDidMount() {
    const { curSiteFlowId, setWorkspaceVisible, resetTimestamp } = this.props;

    if (curSiteFlowId > 0) {
      setWorkspaceVisible(false);
      resetTimestamp();
    }
  }

  componentDidUpdate(prevProps) {
    const {
      curSiteFlowId,
      resetTimestamp,
      fetchPickingCriteriaList01,
      currentPage,
      sorts,
      filters,
      pageSize
    } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      resetTimestamp();
    }

    if (changed('timestamp')) {
      if (curSiteFlowId > 0) {
        fetchPickingCriteriaList01(currentPage, sorts, filters, pageSize);
      }
    }
  }

  componentWillUnmount() {}

  handleSearch(selectedKeys, confirm) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    confirm();
  }

  handleReset(clearFilters) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    clearFilters();
  }

  getDocumentColumns() {
    const { intl, sorts, filters, goToAudit } = this.props;

    return [
      {
        width: 50,
        align: 'right',
        title: '',
        // sort field
        dataIndex: 'line_no',
        ...AntDesignTable.getColumnSortProps(sorts, 'line_no'),
        // filter field
        key: 'line_no',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          '#',
          'line_no',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.line_no}</>
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'user' }),
        // sort field
        dataIndex: 'user_username',
        ...AntDesignTable.getColumnSortProps(sorts, 'user_username'),
        // filter field
        key: 'user_username',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'user' }),
          'user_username',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => record.user_username
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'category' }),
        // sort field
        dataIndex: 'debtor_group_01_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'debtor_group_01_code'),
        // filter field
        key: 'debtor_group01',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'category' }),
          'debtor_group01',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.debtor_group_01_code}</b>
            {record.debtor_group_01_desc_01 && (
              <>
                <br />
                {record.debtor_group_01_desc_01}
              </>
            )}
            {record.debtor_group_01_desc_01 && (
              <>
                <br />
                {record.debtor_group_01_desc_01}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'chain' }),
        // sort field
        dataIndex: 'debtor_group_02_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'debtor_group_02_code'),
        // filter field
        key: 'debtor_group02',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'chain' }),
          'debtor_group02',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.debtor_group_02_code}</b>
            {record.debtor_group_02_desc_01 && (
              <>
                <br />
                {record.debtor_group_02_desc_01}
              </>
            )}
            {record.debtor_group_02_desc_01 && (
              <>
                <br />
                {record.debtor_group_02_desc_01}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'channel' }),
        // sort field
        dataIndex: 'debtor_group_03_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'debtor_group_03_code'),
        // filter field
        key: 'debtor_group03',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'channel' }),
          'debtor_group03',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.debtor_group_03_code}</b>
            {record.debtor_group_03_desc_01 &&
              record.debtor_group_03_code !== record.debtor_group_03_desc_01 && (
                <>
                  <br />
                  {record.debtor_group_03_desc_01}
                </>
              )}
            {record.debtor_group_03_desc_02 &&
              record.debtor_group_03_code !== record.debtor_group_03_desc_02 && (
                <>
                  <br />
                  {record.debtor_group_03_desc_02}
                </>
              )}
          </>
        )
      },
      {
        width: 120,
        align: 'left',
        title: intl.formatMessage({ id: 'debtor' }),
        // sort field
        dataIndex: 'debtor_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'debtor_code'),
        // filter field
        key: 'debtor',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'debtor' }),
          'debtor',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.debtor_code}</b>
            {record.debtor_company_name_01 && (
              <>
                <br />
                {record.debtor_company_name_01}
              </>
            )}
            {record.debtor_company_name_02 && (
              <>
                <br />
                {record.debtor_company_name_02}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'delivery_point' }),
        // sort field
        dataIndex: 'delivery_point_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'delivery_point_code'),
        // filter field
        key: 'delivery_point',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'delivery_point' }),
          'delivery_point',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.delivery_point_code}</b>
            {record.delivery_point_company_name_01 && (
              <>
                <br />
                {record.delivery_point_company_name_01}
              </>
            )}
            {record.delivery_point_company_name_02 && (
              <>
                <br />
                {record.delivery_point_company_name_02}
              </>
            )}
          </>
        )
      },
      {
        width: 100,
        align: 'left',
        title: intl.formatMessage({ id: 'storage_class' }),
        // sort field
        dataIndex: 'str_storage_class',
        ...AntDesignTable.getColumnSortProps(sorts, 'str_storage_class'),
        // filter field
        key: 'str_storage_class',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'storage_class' }),
          'str_storage_class',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.str_storage_class}</>
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'brand' }),
        // sort field
        dataIndex: 'item_group_01_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'item_group_01_code'),
        // filter field
        key: 'item_group01',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'brand' }),
          'item_group01',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.item_group_01_code}</b>
            {record.item_group_01_desc_01 && (
              <>
                <br />
                {record.item_group_01_desc_01}
              </>
            )}
            {record.item_group_01_desc_01 && (
              <>
                <br />
                {record.item_group_01_desc_01}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'category' }),
        // sort field
        dataIndex: 'item_group_02_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'item_group_02_code'),
        // filter field
        key: 'item_group02',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'category' }),
          'item_group02',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.item_group_02_code}</b>
            {record.item_group_02_desc_01 && (
              <>
                <br />
                {record.item_group_02_desc_01}
              </>
            )}
            {record.item_group_02_desc_01 && (
              <>
                <br />
                {record.item_group_02_desc_01}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'manufacturer' }),
        // sort field
        dataIndex: 'item_group_03_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'item_group_03_code'),
        // filter field
        key: 'item_group03',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'manufacturer' }),
          'item_group03',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.item_group_03_code}</b>
            {record.item_group_03_desc_01 && (
              <>
                <br />
                {record.item_group_03_desc_01}
              </>
            )}
            {record.item_group_03_desc_01 && (
              <>
                <br />
                {record.item_group_03_desc_01}
              </>
            )}
          </>
        )
      },
      {
        width: 130,
        align: 'left',
        title: intl.formatMessage({ id: 'item' }),
        // sort field
        dataIndex: 'item_code',
        ...AntDesignTable.getColumnSortProps(sorts, 'item_code'),
        // filter field
        key: 'item',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'item' }),
          'item',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => (
          <>
            <b>{record.item_code}</b>
            {record.item_desc_01 && (
              <>
                <br />
                {record.item_desc_01}
              </>
            )}
            {record.item_desc_02 && (
              <>
                <br />
                {record.item_desc_02}
              </>
            )}
          </>
        )
      },
      {
        width: 100,
        fixed: 'right',
        title: intl.formatMessage({ id: 'min_expiry_month' }),
        // sort field
        dataIndex: 'value',
        ...AntDesignTable.getColumnSortProps(sorts, 'min_expiry_month'),
        // filter field
        key: 'value',
        ...AntDesignTable.getColumnSearchInputProps(
          filters,
          intl.formatMessage({ id: 'min_expiry_month' }),
          'value',
          this.handleSearch,
          this.handleReset
        ),
        render: (text, record) => <>{record.value}</>
      },
      {
        width: 50,
        fixed: 'right',
        title: '',
        key: 'action',
        render: (text, record) => (
          <>
            <Button type="dashed" icon={<AuditOutlined />} onClick={() => goToAudit(record.id)} />
          </>
        )
      }
    ];
  }

  useOnTableChange(pagination, filters, sorter) {
    const { resetTimestamp } = this.props;

    const processedFilters = AntDesignTable.processFilters(filters);
    const processedSorts = AntDesignTable.processSorts(sorter);

    resetTimestamp(pagination.current, processedSorts, processedFilters, pagination.pageSize);
  }

  useShowWorkspace() {
    const { setWorkspaceVisible } = this.props;

    setWorkspaceVisible(true);
  }

  render() {
    const {
      resetTimestamp,
      currentPage,
      pageSize,
      total,
      documents,
      fetchIsLoading,
      selectedDocuments,
      addSelectedDocuments,
      removeSelectedDocuments
    } = this.props;

    return (
      <>
        <Table
          size="small"
          // rowSelection={rowSelection}
          rowKey="id"
          pagination={{
            current: currentPage,
            pageSize: parseInt(pageSize, 10),
            total,
            showTotal: () => `${total} items`
          }}
          columns={this.getDocumentColumns()}
          dataSource={documents}
          loading={fetchIsLoading}
          bordered
          rowSelection={{
            selectedRowKeys: selectedDocuments.map(value => value.id),
            onChange: () => {
              // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            },
            onSelect: (record, selected) => {
              // console.log(`onSelect record: `, record, 'selected: ', selected, 'selectedRows: ', selectedRows);
              if (selected === true) {
                addSelectedDocuments([record]);
              } else {
                removeSelectedDocuments([record]);
              }
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
              // console.log('onSelectAll selected: ', selected, 'selectedRows: ', selectedRows, 'changeRows: ', changeRows);
              if (selected === true) {
                addSelectedDocuments(changeRows);
              } else {
                removeSelectedDocuments(changeRows);
              }
            },
            onSelectInvert: selectedRows => {
              // console.log('onSelectInvert selectedRows: ', selectedRows);
              removeSelectedDocuments(selectedRows);
            },
            getCheckboxProps: () => ({
              // Column configuration not to be checked
              disabled: true
              // name: record.name,
            })
          }}
          onChange={this.useOnTableChange}
          title={() => (
            <>
              <Row type="flex" justify="space-between" gutter={[0, 16]}>
                <Col span={8}>
                  <Button
                    type="primary"
                    // disabled={!isValid}
                    loading={fetchIsLoading}
                    onClick={() => resetTimestamp()}
                    icon={<ReloadOutlined />}
                  />
                </Col>
              </Row>
            </>
          )}
          scroll={{ x: 950 }}
        />

        <div
          style={{
            position: 'fixed',
            bottom: '50px',
            right: '50px',
            zIndex: 9999
          }}
        >
          <Badge count={selectedDocuments.length}>
            <Button
              size="large"
              type="primary"
              shape="circle"
              icon={<LaptopOutlined />}
              onClick={this.useShowWorkspace}
              loading={fetchIsLoading}
            />
          </Badge>
        </div>
      </>
    );
  }
}

PickingCriteriaList01Table.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  resetTimestamp: PropTypes.func,
  // goToDocument: PropTypes.func,
  goToAudit: PropTypes.func,

  setWorkspaceVisible: PropTypes.func,

  addSelectedDocuments: PropTypes.func,
  removeSelectedDocuments: PropTypes.func,
  documents: PropTypes.arrayOf(PropTypes.object),
  selectedDocuments: PropTypes.arrayOf(PropTypes.object),

  sorts: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  filters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),

  currentPage: PropTypes.number,
  pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  total: PropTypes.number,
  fetchIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchPickingCriteriaList01: PropTypes.func
};

PickingCriteriaList01Table.defaultProps = {
  intl: {},
  resetTimestamp() {},
  // goToDocument() {},
  goToAudit() {},

  setWorkspaceVisible() {},

  addSelectedDocuments() {},
  removeSelectedDocuments() {},
  documents: [],
  selectedDocuments: [],

  sorts: {},
  filters: {},

  currentPage: 1,
  pageSize: '20',
  total: 0,
  fetchIsLoading: false,

  curSiteFlowId: 0,
  fetchPickingCriteriaList01() {}
};

const mapStateToProps = state => ({
  timestamp: state.pickingCriteriaList01.timestamp,
  workspaceIsVisible: state.pickingCriteriaList01.workspaceIsVisible,

  documents: state.pickingCriteriaList01.documents,
  selectedDocuments: state.pickingCriteriaList01.selectedDocuments,

  sorts: state.pickingCriteriaList01.sorts,
  filters: state.pickingCriteriaList01.filters,

  currentPage: state.pickingCriteriaList01.currentPage,
  pageSize: state.pickingCriteriaList01.pageSize,
  total: state.pickingCriteriaList01.total,
  fetchIsLoading: state.pickingCriteriaList01.fetchIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  resetTimestamp: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      PickingCriteriaList01Actions.pickingCriteriaList01ResetTimestamp(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    ),
  // goToDocument: hdrId =>
  //   dispatch(PickingCriteriaList01Actions.pickingCriteriaList01GoToDocument(hdrId)),
  goToAudit: hdrId => dispatch(PickingCriteriaList01Actions.pickingCriteriaList01GoToAudit(hdrId)),

  setWorkspaceVisible: boolean =>
    dispatch(PickingCriteriaList01Actions.pickingCriteriaList01SetWorkspaceVisible(boolean)),

  addSelectedDocuments: selectedDocuments =>
    dispatch(
      PickingCriteriaList01Actions.pickingCriteriaList01AddSelectedDocuments(selectedDocuments)
    ),
  removeSelectedDocuments: selectedDocuments =>
    dispatch(
      PickingCriteriaList01Actions.pickingCriteriaList01RemoveSelectedDocuments(selectedDocuments)
    ),

  fetchPickingCriteriaList01: (currentPage, sorts, filters, pageSize) =>
    dispatch(
      PickingCriteriaList01Actions.pickingCriteriaList01FetchPickingCriteriaList01(
        currentPage,
        sorts,
        filters,
        pageSize
      )
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PickingCriteriaList01Table));
